import type { Theme } from '../../lib/theme';
import { Button } from './Button';

export interface ThemeToggleProps {
  theme: Theme;
  onChange: (t: Theme) => void;
  className?: string;
}

const SUN = (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    aria-hidden="true"
    focusable="false"
    className="pn-theme-toggle-ico"
  >
    <circle cx="8" cy="8" r="3" />
    <path
      d="M8 1.5v1.8M8 12.7v1.8M1.5 8h1.8M12.7 8h1.8M3.4 3.4l1.3 1.3M11.3 11.3l1.3 1.3M3.4 12.6l1.3-1.3M11.3 4.7l1.3-1.3"
      strokeLinecap="round"
    />
  </svg>
);

const MOON = (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    aria-hidden="true"
    focusable="false"
    className="pn-theme-toggle-ico"
  >
    <path d="M13 9.5A5.5 5.5 0 1 1 6.5 3a4.5 4.5 0 0 0 6.5 6.5z" strokeLinejoin="round" />
  </svg>
);

/**
 * Light / dark theme toggle. Single header-variant button — icon + label —
 * matching dashboard.html `.hbtn` canon. Clicking flips the theme. Controlled:
 * caller owns `useTheme()` and passes `theme` + `onChange` in.
 */
export function ThemeToggle({ theme, onChange, className }: ThemeToggleProps) {
  const next: Theme = theme === 'dark' ? 'light' : 'dark';
  return (
    <Button
      variant="header"
      className={['pn-theme-toggle', className].filter(Boolean).join(' ')}
      onClick={() => onChange(next)}
      aria-label="Toggle theme"
      data-testid="theme-toggle"
      data-theme-state={theme}
    >
      {theme === 'dark' ? MOON : SUN}
      <span className="pn-theme-toggle-label">
        {theme === 'dark' ? 'Dark' : 'Light'}
      </span>
    </Button>
  );
}
